import { useRef } from "react";
import { useRouter } from "next/router";
import Image from "next/image";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Autoplay } from "swiper/modules";
import { useTranslation } from "next-i18next";

const asSeenLogos = [
  "/asSeen/khaleej-times-logo.webp",
  "/asSeen/zawya.webp",
  "/asSeen/campaign.webp",
  "/asSeen/menafn.webp",
  "/asSeen/pr.webp",
  "/asSeen/adgully.webp",
];

const AsSeenSection2 = () => {
  const { t } = useTranslation("common");
  const router = useRouter();
  const lang = router.locale || "en";

  return (
    <div className="w-full bg-black">
      <section className="w-full box-border border-b border-gray-300 border-solid  self-stretch flex items-center justify-center  px-[24px] md:px-[60px] lg:px-[80px] xl:px-[80px] py-[40px] md:py-[40px] lg:py-[60px] lg:py-[60px]  max-w-[1600px] mx-auto">
        <div className="flex lg:flex-row flex-col gap-10 items-center w-full">
          <h2 className="w-full  font-medium text-[28px] sm:text-[32px] lg:text-[40px] leading-[120%] text-center m-0 text-white">
            {t("asSeen.title")}
          </h2>
          <div className="lg:w-[80%] w-full">
            <Swiper
              dir={lang === "ar" && "ltr"}
              modules={[Autoplay]}
              spaceBetween={60}
              slidesPerView={1}
              breakpoints={{
                640: { slidesPerView: 2 },
                768: { slidesPerView: 2 },
                1024: { slidesPerView: 3 },
                1280: { slidesPerView: 4 },
              }}
              // autoplay={{ delay: 5000 }}
              autoplay={{
                delay: 5000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }}
              className="w-full max-w-full"
            >
              {asSeenLogos &&
                asSeenLogos.length > 0 &&
                asSeenLogos.map((item, ind) => (
                  <SwiperSlide key={ind}>
                    <div className="flex  items-center justify-center">
                      <Image
                        src={item}
                        alt={`${item?.split(".")?.[0]?.split("/")?.[2]} logo`}
                        width={160}
                        height={80}
                        className="bg-white p-1 object-contain rounded-[4px]"
                      />
                    </div>
                  </SwiperSlide>
                ))}
            </Swiper>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AsSeenSection2;
